var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SalesDashboardCard",
    {
      attrs: {
        title: "Earnings",
        "class-card": "col-md-4",
        "selected-filter": _vm.selectedFilter,
        filters: _vm.filters
      },
      on: { "set-filter": _vm.setFilter }
    },
    [
      _c("div", { attrs: { slot: "icon" }, slot: "icon" }, [
        _c("span", {
          staticClass: "dashboard-card-icon dashboard-card-icon-earnings"
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between",
          attrs: { slot: "body" },
          slot: "body"
        },
        [
          _vm.loading
            ? _c("Loader")
            : [
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c("span", { staticClass: "total-title" }, [
                    _vm._v("Cluster earned")
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "total-value d-flex align-items-center flex-wrap"
                    },
                    [
                      _c("span", [_vm._v("$ " + _vm._s(_vm.total_earned))]),
                      _vm._v(" "),
                      _vm.compared_earned < 0 || _vm.compared_earned > 0
                        ? _c(
                            "span",
                            {
                              staticClass: "compared-value",
                              class: {
                                "compared-value-positive":
                                  parseInt(_vm.compared_earned) > 0,
                                "compared-value-negative":
                                  parseInt(_vm.compared_earned) < 0
                              }
                            },
                            [_vm._v(_vm._s(_vm.compared_earned) + "%")]
                          )
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c("span", { staticClass: "total-title" }, [
                    _vm._v("Carriers payout")
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "total-value d-flex align-items-center flex-wrap"
                    },
                    [
                      _c("span", [_vm._v("$ " + _vm._s(_vm.total_payout))]),
                      _vm._v(" "),
                      _vm.compared_payout < 0 || _vm.compared_payout > 0
                        ? _c(
                            "span",
                            {
                              staticClass: "compared-value",
                              class: {
                                "compared-value-positive":
                                  parseInt(_vm.compared_payout) > 0,
                                "compared-value-negative":
                                  parseInt(_vm.compared_payout) < 0
                              }
                            },
                            [_vm._v(_vm._s(_vm.compared_payout) + "%")]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-550495ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-550495ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/Earnings.vue
// module id = null
// module chunks = 